const requestTails = new Map()

/**
 * Serialize operations that mutate one optimistic-lock version.
 *
 * A rejected operation must not poison the queue: its caller still receives
 * the rejection, while the next operation starts after that rejection settled.
 */
export function enqueueSerializedRequest(key, operation) {
  const previous = requestTails.get(key) ?? Promise.resolve()
  const current = previous.catch(() => undefined).then(operation)

  requestTails.set(key, current)

  return current
}
